export const ProjectsActionTypes = {
    SET_PROJECT_DATA: 'SET_PROJECT_DATA',
    SET_PROJECTS_DATA:'SET_PROJECTS_DATA',
    SET_PROJECT_EDITING:'SET_PROJECT_EDITING',
    SET_SELECTED_PROJECT:'SET_SELECTED_PROJECT',
    REMOVE_SELECTED_PROJECT:'REMOVE_SELECTED_PROJECT'
  };